/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/sale_transactions-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/sale_transactions-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/sale_transactions-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-sale_transactions-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/sale_transactions.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Source config: config/entities/sale_transactions-entity-config.ts
 * Public fields: 34/34 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const SaleTransactionsSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  transaction_type_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // transaction_type_id field
  transaction_status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // transaction_status_id field
  source_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // source_id field
  external_ref: Type.Union([Type.String(), Type.Null()]), // external_ref field
  asking_price: Type.Union([Type.Number(), Type.Null()]), // asking_price field
  price_per_sf: Type.Union([Type.Number(), Type.Null()]), // price_per_sf field
  price_per_ac: Type.Union([Type.Number(), Type.Null()]), // price_per_ac field
  price_per_unit: Type.Union([Type.Number(), Type.Null()]), // price_per_unit field
  cap_rate: Type.Union([Type.Number(), Type.Null()]), // cap_rate field
  close_date: Type.Union([Type.String(), Type.Null()]), // close_date field
  listed_date: Type.Union([Type.String(), Type.Null()]), // listed_date field
  comments: Type.Union([Type.String(), Type.Null()]), // comments field
  verified_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // verified_at field
  verified_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // verified_by_user_profile_id field
  created_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // created_by_user_profile_id field
  updated_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // updated_by_user_profile_id field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
  updated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // updated_at field
  permission_level_id: Type.String({ format: "uuid" }), // permission_level_id field
  is_colliers_sale: Type.Boolean(), // is_colliers_sale field
  external_key: Type.Union([Type.String(), Type.Null()]), // external_key field
  sale_price: Type.Union([Type.Number(), Type.Null()]), // sale_price field
  review_status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // review_status_id field
  reviewed_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // reviewed_at field
  reviewed_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // reviewed_by_user_profile_id field
  created_by_ingestion_job_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // created_by_ingestion_job_id field
  internal_ref: Type.Union([Type.String(), Type.Null()]), // internal_ref field
  conditions_of_sale_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // conditions_of_sale_id field
  is_investment: Type.Union([Type.Boolean(), Type.Null()]), // is_investment field
  archived_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // archived_at field
  archived_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // archived_by_user_profile_id field
  archive_reason: Type.Union([Type.String(), Type.Null()]), // archive_reason field
  archive_batch_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // archive_batch_id field
});

export const CreateSaleTransactionsSchema = Type.Object({
  transaction_type_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // transaction_type_id field
  transaction_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // transaction_status_id field
  source_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // source_id field
  external_ref: Type.Optional(Type.Union([Type.String(), Type.Null()])), // external_ref field
  asking_price: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // asking_price field
  price_per_sf: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // price_per_sf field
  price_per_ac: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // price_per_ac field
  price_per_unit: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // price_per_unit field
  cap_rate: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // cap_rate field
  close_date: Type.Optional(Type.Union([Type.String(), Type.Null()])), // close_date field
  listed_date: Type.Optional(Type.Union([Type.String(), Type.Null()])), // listed_date field
  comments: Type.Optional(Type.Union([Type.String(), Type.Null()])), // comments field
  verified_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // verified_at field
  verified_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // verified_by_user_profile_id field
  created_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // created_by_user_profile_id field
  updated_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // updated_by_user_profile_id field
  permission_level_id: Type.Optional(Type.String({ format: "uuid" })), // permission_level_id field
  is_colliers_sale: Type.Optional(Type.Boolean()), // is_colliers_sale field
  external_key: Type.Optional(Type.Union([Type.String(), Type.Null()])), // external_key field
  sale_price: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // sale_price field
  review_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // review_status_id field
  reviewed_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // reviewed_at field
  reviewed_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // reviewed_by_user_profile_id field
  created_by_ingestion_job_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // created_by_ingestion_job_id field
  internal_ref: Type.Optional(Type.Union([Type.String(), Type.Null()])), // internal_ref field
  conditions_of_sale_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // conditions_of_sale_id field
  is_investment: Type.Optional(Type.Union([Type.Boolean(), Type.Null()])), // is_investment field
});

export const UpdateSaleTransactionsSchema = Type.Object({
  transaction_type_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // transaction_type_id field
  transaction_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // transaction_status_id field
  source_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // source_id field
  external_ref: Type.Optional(Type.Union([Type.String(), Type.Null()])), // external_ref field
  asking_price: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // asking_price field
  price_per_sf: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // price_per_sf field
  price_per_ac: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // price_per_ac field
  price_per_unit: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // price_per_unit field
  cap_rate: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // cap_rate field
  close_date: Type.Optional(Type.Union([Type.String(), Type.Null()])), // close_date field
  listed_date: Type.Optional(Type.Union([Type.String(), Type.Null()])), // listed_date field
  comments: Type.Optional(Type.Union([Type.String(), Type.Null()])), // comments field
  verified_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // verified_at field
  verified_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // verified_by_user_profile_id field
  created_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // created_by_user_profile_id field
  updated_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // updated_by_user_profile_id field
  permission_level_id: Type.Optional(Type.String({ format: "uuid" })), // permission_level_id field
  is_colliers_sale: Type.Optional(Type.Boolean()), // is_colliers_sale field
  external_key: Type.Optional(Type.Union([Type.String(), Type.Null()])), // external_key field
  sale_price: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // sale_price field
  review_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // review_status_id field
  reviewed_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // reviewed_at field
  reviewed_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // reviewed_by_user_profile_id field
  created_by_ingestion_job_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // created_by_ingestion_job_id field
  internal_ref: Type.Optional(Type.Union([Type.String(), Type.Null()])), // internal_ref field
  conditions_of_sale_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // conditions_of_sale_id field
  is_investment: Type.Optional(Type.Union([Type.Boolean(), Type.Null()])), // is_investment field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type SaleTransactionsRow = Static<typeof SaleTransactionsSchema>;
export type SaleTransactionsInsert = Static<typeof CreateSaleTransactionsSchema>;
export type SaleTransactionsUpdate = Static<typeof UpdateSaleTransactionsSchema>;

// Legacy type aliases for backward compatibility
export type SaleTransactions = SaleTransactionsRow;
export type CreateSaleTransactions = SaleTransactionsInsert;
export type UpdateSaleTransactions = Static<typeof UpdateSaleTransactionsSchema>;

// Field configuration metadata
export const SaleTransactionsFieldConfig = {
  filterable: ['id', 'transaction_type_id', 'transaction_status_id', 'source_id', 'verified_by_user_profile_id', 'created_by_user_profile_id', 'updated_by_user_profile_id', 'permission_level_id', 'review_status_id', 'reviewed_by_user_profile_id', 'created_by_ingestion_job_id', 'conditions_of_sale_id', 'archived_by_user_profile_id', 'archive_batch_id'] as const,
  sortable: ['close_date', 'listed_date', 'created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['id', 'permission_level_id', 'is_colliers_sale'] as const,
  readonly: ['id', 'created_at', 'updated_at', 'archived_at', 'archived_by_user_profile_id', 'archive_reason', 'archive_batch_id'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../config/search/global-search-config.js';

export interface SaleTransactionsQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface SaleTransactionsResponse {
  data: SaleTransactions[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleSaleTransactionsResponse {
  data: SaleTransactions | null;
  error: Error | null;
}
